import React, {useEffect, useRef} from "react";
import PopUp from "../base/popup";

export default function EducatorRestrictionModal(props) {

    const popup = useRef(null);

    useEffect(() => {
        popup.current.open();
    }, []);

    const onClose = () => {
        document.location.href='/group/overview'
    };

    return (
        <PopUp ref={popup} onClose={onClose} >
            <div className="grid-x align-center">
                <div className="cell text-center">
                    <h3 className="mar-bot-10">Your Access</h3>
                    <p className='popup__text'>Access to purchase is not permitted from your account.</p>
                    <p className='popup__text'><a href={'/contact'}>Contact us</a> to request additional access. </p>
                </div>
            </div>
        </PopUp>
    )
}